import SparkMD5 from "spark-md5"

// 文件过大时切片计算
const splitSize = 2 * 1024 * 1024

// 切片时的大小
const chunkSize = 2 * 1024 * 1024

// 计算文件md5
export const computedMD5 = file => {
    if (!file.size) return

    return new Promise(resolve => {
        if (file.size <= splitSize) {
            let fileReader = new FileReader()
            fileReader.onload = e => {
                resolve(SparkMD5.hashBinary(e.target.result))
            }
            fileReader.readAsBinaryString(file)
        } else {
            let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
            let chunks = Math.ceil(file.size / chunkSize)
            let currentChunk = 0
            let spark = new SparkMD5.ArrayBuffer()
            let fileReader = new FileReader()

            fileReader.onload = e => {
                spark.append(e.target.result)
                currentChunk ++

                if (currentChunk < chunks) {
                    loadNext()
                } else {
                    let md5 = spark.end()
                    spark.destroy()
                    resolve(md5)
                }
            }

            fileReader.onerror = () => {
                file.cancel()
            }

            let loadNext = () => {
                let start = currentChunk * chunkSize
                let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
                fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
            }

            loadNext()
        }
    })
}
